import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -10
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function WhoIsThisFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forYou = ['You own firearms and value your privacy above all else', "You're tired of safes that advertise your collection to every thief in the neighborhood", "You want a solution that doesn't show up on any delivery manifest or purchase record", "You're willing to spend a weekend and $500 to build something that lasts forever", "You believe your home security is YOUR responsibility — not a corporation's", "You want your family protected even when you're not home"];
  const notForYou = ["You're looking for a quick plug-and-play solution with zero effort", "You rent your home and can't make structural modifications", 'You trust that a $3,000 retail safe will actually stop a determined thief', "You're comfortable with delivery trucks announcing your purchases to the neighborhood", "You'd rather pay someone else to handle your security (and hope they keep quiet)"];
  return <section ref={ref} className="w-full bg-dark-bg py-20 md:py-28" data-id="element-424">
      <div className="max-w-4xl mx-auto px-6" data-id="element-425">
        <motion.h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white text-center mb-16 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-426">
          IS THIS <span className="text-orange-accent" data-id="element-427">FOR YOU</span>?
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-428">
          {/* For You Column */}
          <motion.div className="bg-dark-card border border-green-500/20 p-6 md:p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-429">
            <h3 className="font-bebas text-2xl text-green-400 mb-6 tracking-wide" data-id="element-430">
              THIS IS FOR YOU IF...
            </h3>
            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-431">
              {forYou.map(item => <motion.li key={item} variants={itemVariants} className="flex gap-3" data-id="element-432">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-433" />
                  <span className="font-inter text-concrete leading-relaxed" data-id="element-434">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div className="bg-dark-card border border-red-500/20 p-6 md:p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-435">
            <h3 className="font-bebas text-2xl text-red-400 mb-6 tracking-wide" data-id="element-436">
              THIS IS NOT FOR YOU IF...
            </h3>
            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-437">
              {notForYou.map(item => <motion.li key={item} variants={itemVariants} className="flex gap-3" data-id="element-438">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-439" />
                  <span className="font-inter text-concrete leading-relaxed" data-id="element-440">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}